/** Gatsby Browser APIs — CommonJS only */
const React = require('react')
const Layout = require('./src/layout/index.js').default

if (typeof window !== 'undefined') {
  // some libs check global
  window.global = window
}

const transitionDelay = 400

exports.shouldUpdateScroll = ({ routerProps: { location }, getSavedScrollPosition }) => {
  if (location.action === 'PUSH') {
    window.setTimeout(() => window.scrollTo(0, 0), transitionDelay)
  } else {
    const savedPosition = getSavedScrollPosition(location)
    window.setTimeout(() => window.scrollTo(...(savedPosition || [0, 0])), transitionDelay)
  }
  return false
}

exports.wrapPageElement = ({ element, props }) =>
  React.createElement(Layout, props, element)
